module.exports = __webpack_public_path__ + "img/icon-info.c0d1f3ea.png";